import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { InputSwitch, Text } from "@pentabd/ui";

import { InputTextAreaRow, InputTextRow } from "@components";

import { FORM_FIELDS } from "@constants/form";

const FINAL_RECEIVING = FORM_FIELDS.PROCUREMENT_DETAILS.FINAL_RECEIVING;

export default function BasicInfo() {
  const { register, setValue, watch } = useFormContext();
  const { t } = useTranslation();

  const tenderMoneyReturn = watch(FINAL_RECEIVING.TENDER_MONEY_RETURN);
  const performanceMoneyReturn = watch(
    FINAL_RECEIVING.PERFORMANCE_MONEY_RETURN,
  );

  return (
    <>
      {/* <MultiFileRow
        control={control}
        name={FINAL_RECEIVING.REPORT_UPLOAD}
        register={register}
        setValue={setValue}
        label="PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.REPORT_UPLOAD"
      />

      <InputDateControllerRow
        control={control}
        label="PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.REPORT_DATE"
        name={FINAL_RECEIVING.REPORT_DATE}
        register={{ ...register(FINAL_RECEIVING.REPORT_DATE) }}
      />

      <InputTextAreaRow
        label="PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.REMARKS"
        register={{ ...register(FINAL_RECEIVING.REMARKS) }}
      /> */}

      <InputTextAreaRow
        label="PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.DETAILS"
        register={{ ...register(FINAL_RECEIVING.DETAILS) }}
      />

      <InputTextAreaRow
        label="PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.REMARKS_ABOUT_SUPPLIER"
        register={{ ...register(FINAL_RECEIVING.REMARKS_ABOUT_SUPPLIER) }}
      />

      {/* <div className="row">
        <div className="col-lg-3">
          <Text weight="semibold" color="title" size="sm">
            {t(
              "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.TENDER_MONEY_RETURN.LABEL",
            )}
          </Text>
        </div>
        <div className="col-lg-7">
          <RadioGroup
            id={FINAL_RECEIVING.TENDER_MONEY_RETURN}
            {...register(FINAL_RECEIVING.TENDER_MONEY_RETURN)}
            options={[
              {
                id: "1",
                label: t(
                  "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.TENDER_MONEY_RETURN.YES",
                ),
                value: true as unknown as string,
              },
              {
                id: "2",
                label: t(
                  "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.TENDER_MONEY_RETURN.NO",
                ),
                value: false as unknown as string,
              },
            ]}
            size="sm"
          />
        </div>
      </div> */}

      <div className="row py-6">
        <div className="col-lg-3">
          <Text weight="semibold" color="title" size="sm">
            {t(
              "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.TENDER_MONEY_RETURN.LABEL",
            )}
          </Text>
        </div>
        <div className="col-lg-7 d-flex gap-5">
          <InputSwitch
            id={FINAL_RECEIVING.TENDER_MONEY_RETURN}
            {...register(FINAL_RECEIVING.TENDER_MONEY_RETURN)}
            onChange={(e) =>
              setValue(FINAL_RECEIVING.TENDER_MONEY_RETURN, e.target.checked)
            }
            controlling
          />
          <Text color="subtitle1" size="sm">
            {tenderMoneyReturn
              ? t(
                  "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.TENDER_MONEY_RETURN.YES",
                )
              : t(
                  "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.TENDER_MONEY_RETURN.NO",
                )}
          </Text>
        </div>
      </div>

      <InputTextRow
        label="PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.TENDER_MONEY_AMOUNT"
        register={{
          ...register(FINAL_RECEIVING.TENDER_MONEY_AMOUNT),
        }}
        type="number"
      />

      {/* <div className="row">
        <div className="col-lg-3">
          <Text weight="semibold" color="title" size="sm">
            {t(
              "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.PERFORMANCE_MONEY_RETURN.LABEL",
            )}
          </Text>
        </div>
        <div className="col-lg-7">
          <RadioGroup
            id={FINAL_RECEIVING.PERFORMANCE_MONEY_RETURN}
            {...register(FINAL_RECEIVING.PERFORMANCE_MONEY_RETURN)}
            options={[
              {
                id: "3",
                label: t(
                  "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.PERFORMANCE_MONEY_RETURN.YES",
                ),
                value: true as unknown as string,
              },
              {
                id: "4",
                label: t(
                  "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.PERFORMANCE_MONEY_RETURN.NO",
                ),
                value: false as unknown as string,
              },
            ]}
            size="sm"
          />
        </div>
      </div> */}

      <div className="row py-6">
        <div className="col-lg-3">
          <Text weight="semibold" color="title" size="sm">
            {t(
              "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.PERFORMANCE_MONEY_RETURN.LABEL",
            )}
          </Text>
        </div>
        <div className="col-lg-7 d-flex gap-5">
          <InputSwitch
            id={FINAL_RECEIVING.PERFORMANCE_MONEY_RETURN}
            {...register(FINAL_RECEIVING.PERFORMANCE_MONEY_RETURN)}
            onChange={(e) =>
              setValue(
                FINAL_RECEIVING.PERFORMANCE_MONEY_RETURN,
                e.target.checked,
              )
            }
            controlling
          />
          <Text color="subtitle1" size="sm">
            {performanceMoneyReturn
              ? t(
                  "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.PERFORMANCE_MONEY_RETURN.YES",
                )
              : t(
                  "PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.PERFORMANCE_MONEY_RETURN.NO",
                )}
          </Text>
        </div>
      </div>

      <InputTextRow
        label="PROCUREMENT_CREATE.FINAL_RECEIVING.FORM.PERFORMANCE_MONEY_AMOUNT"
        register={{
          ...register(FINAL_RECEIVING.PERFORMANCE_MONEY_AMOUNT),
        }}
        type="number"
      />
    </>
  );
}
